import classNames from 'classnames'
import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { IFees, fees as hardFees } from './utilities'
import AcceptIcon from 'assets/images/loans/accepted.svg'
import { Field, Form, Formik } from 'formik'
import { NumericFormat } from 'react-number-format'

interface IModalProps {
    show: boolean
    onHide: () => void
    setSelectedFee: React.Dispatch<React.SetStateAction<number | undefined>>
    setSelectedFeeType: React.Dispatch<React.SetStateAction<string>>
}
export default function FeeModal({
    show,
    onHide,
    setSelectedFee,
    setSelectedFeeType,
}: IModalProps) {
    const [selected, setSelected] = useState<number>(0)
    const [fees, setFees] = useState(hardFees)

    const handleSelect = (item: IFees) => {
        const newFees: IFees[] = []
        fees.map((selecItem) => {
            if (selecItem.value === item.value) {
                newFees.push({
                    ...selecItem,
                    isSelected: true,
                })
            } else {
                newFees.push({
                    ...selecItem,
                    isSelected: false,
                })
            }
        })
        setFees(newFees)
    }
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center pt-4 text-sm">
                <Formik
                    initialValues={{ amount: '' }}
                    onSubmit={async (values) => {
                        if (selected === 0) {
                            const findSelected = fees.find(
                                (item) => item.isSelected
                            )
                            if (findSelected) {
                                setSelectedFee(findSelected?.value)
                                setSelectedFeeType('percentage')
                            }
                        } else if (selected === 1) {
                            setSelectedFee(Number(values.amount))
                            setSelectedFeeType('fixed')
                        }
                        onHide()
                    }}
                >
                    {({ values, touched, errors, setFieldValue }) => (
                        <Form>
                            <Tabs>
                                <TabList>
                                    <div className=" flex w-full justify-between text-center">
                                        <Tab
                                            className={classNames(
                                                'w-full py-2',
                                                selected === 0 &&
                                                    ' text-green-1 border-b border-green-1'
                                            )}
                                            onClick={() => setSelected(0)}
                                        >
                                            درصد
                                        </Tab>
                                        <Tab
                                            className={classNames(
                                                'w-full py-2',
                                                selected === 1 &&
                                                    ' text-green-1 border-b border-green-1'
                                            )}
                                            onClick={() => setSelected(1)}
                                        >
                                            مبلغ ثابت
                                        </Tab>
                                    </div>
                                </TabList>
                                <div className=" mt-4">
                                    <TabPanel>
                                        <div className="">
                                            {fees.map((item) => (
                                                <div
                                                    key={item.value}
                                                    className={classNames(
                                                        ' my-3 flex justify-between items-center px-2 mx-10 cursor-pointer py-1',
                                                        item.isSelected &&
                                                            ' rounded-full border-1 border-green-1'
                                                    )}
                                                    onClick={() =>
                                                        handleSelect(item)
                                                    }
                                                >
                                                    <p
                                                        className={classNames(
                                                            ' text-sm',
                                                            item.isSelected &&
                                                                'text-green-1'
                                                        )}
                                                    >
                                                        {item.value} درصد
                                                    </p>
                                                    {item.isSelected ? (
                                                        <img
                                                            src={AcceptIcon}
                                                            alt="accept"
                                                        />
                                                    ) : (
                                                        <div className="h-2 w-2 rounded-full p-1.5 border-1 border-gray-4"></div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </TabPanel>
                                    <div className=" mt-4">
                                        <TabPanel>
                                            <>
                                                <NumericFormat
                                                    customInput={Field}
                                                    thousandSeparator
                                                    placeholder="مبلغ کارمزد (تومان)"
                                                    allowNegative={false}
                                                    name="amount"
                                                    className="  w-full outline-0 text-center py-10 px-4 text-sm"
                                                    onValueChange={(values) => {
                                                        const { value } = values
                                                        setFieldValue(
                                                            'amount',
                                                            value
                                                        )
                                                    }}
                                                />
                                            </>
                                        </TabPanel>
                                    </div>
                                </div>
                            </Tabs>
                            <button
                                type="submit"
                                className=" text-sm text-center w-full bg-transparent border-t border-gray-5 py-3 text-green-1"
                            >
                                تایید
                            </button>
                        </Form>
                    )}
                </Formik>
            </div>
        </Modal>
    )
}
